<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h4
          class="LkMunMehReviewForm__content__title__header mx-0"
          v-text="'Параметры оценивания компонента'"
        />
      </v-col>
    </v-row>

    <v-row
      v-for="(value, valueIdx) in indicatorValues"
      :key="`${level.id}.V${valueIdx}`"
    >
      <v-col cols="6" style="align-self: center;">
        <div class="LKMunMehReviewFourLevels__Values">
          <div class="name" v-text="value.text" />
        </div>
      </v-col>
      <v-col :cols="6">
        <div class="LKMunMehReviewFourLevels__Values">
          <v-row>
            <v-col :cols="secondLevel ? 3 : 8" class="text-right">
              <div class="score" v-text="value.max_score" />
            </v-col>
            <template v-if="secondLevel">
              <v-col cols="3" class="text-right">
                <div
                  :class="{ score: true, 'red--text': value.isRedText }"
                  v-text="value.expertOneMark"
                />
              </v-col>
              <v-col cols="3" class="text-right">
                <div
                  :class="{ score: true, 'red--text': value.isRedText }"
                  v-text="value.expertTwoMark"
                />
              </v-col>
            </template>
            <v-col :cols="secondLevel ? 3 : 4" class="text-right">
              <BTextField
                :value="hasDocs ? value.expertMark : '0'"
                :validate="value.rules"
                :disabled="!hasDocs || disabled"
                :skeleton="marksLoading"
                @input="onChangedInput(level.id, value.id, $event)"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BTextField from '@/components/forms/BTextField.vue'

import { LKMunMehReviewMapper } from '@/views/LKMunMeh/Review/store'

export default {
  components: {
    BTextField,
  },
  props: {
    level: {
      type: Object,
      required: true,
    },
    marksLoading: {
      type: Boolean,
      required: true,
    },
    disabled: Boolean,
    secondLevel: Boolean,
  },
  computed: {
    ...LKMunMehReviewMapper.mapGetters([
      'getDocuments',
      'getMarkForIndicatorValue',
      'getNameForIndicatorValue',
      'getMarkForExpertOneIndicatorValue',
      'getMarkForExpertTwoIndicatorValue',
    ]),
    indicatorValues() {
      return (this.level?.values || []).map((el) => ({
        text: this.getNameForIndicatorValue(el.id),
        expertMark: this.getMarkForIndicatorValue(el.id),
        expertOneMark: this.getMarkForExpertOneIndicatorValue(el.id),
        expertTwoMark: this.getMarkForExpertTwoIndicatorValue(el.id),
        rules: this.getMarkRules(el),
        max_score: el.max_score,
        id: el.id,
        isRedText: this.isRedText(el.id),
      }))
    },
    hasDocs() {
      return this.docs.length > 0
    },
    docs() {
      return this.getDocuments(this.level.id)?.data || []
    },
  },
  methods: {
    ...LKMunMehReviewMapper.mapMutations(['setValue']),
    onChangedInput(indicatorId, indicatorValueId, value) {
      this.setValue({ indicatorId, indicatorValueId, value })
    },
    isRedText(indicatorValueId) {
      return this.getMarkForExpertOneIndicatorValue(indicatorValueId)
            !== this.getMarkForExpertTwoIndicatorValue(indicatorValueId)
    },
    getMarkRules(value) {
      const min = Math.min(0, value.max_score)
      const max = Math.max(0, value.max_score)
      return { required: true, between: { min, max } }
    },
  },
}
</script>
